<template>
  <div id="app" class="font-sans bg-white text-neutral-900 antialiased">
    <Navbar />
    <router-view/>
    <AppFooter />
    <ToolDetailModal />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import AppFooter from './components/Footer.vue'
import ToolDetailModal from './components/ToolDetailModal.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    AppFooter,
    ToolDetailModal
  }
}
</script>
